import debounce from 'lodash/debounce';

import Component from "./component"

export const SELECTORS = Object.freeze({
    main: '.main-menu',
    drawer: `.main-menu--drawer`,
})

const DRAWER_OPEN_CLASS = 'menu--open'

const DRAWER_STATE = Object.freeze({
    open: 'open',
    closed: 'closed'
})

// Singeton
export default class Drawer extends Component {
    #drawerState = DRAWER_STATE.closed
    resizeCallback = null

    constructor() {
        super()

        if (Drawer.instance) {
            return Drawer.instance
        }

        Drawer.instance = this

        this.#init()
    }

    #init = () => {
        try {
            this.registerNewElement('main', this.getElementBySelector(SELECTORS.main))
            this.registerNewElement('drawer', this.getElementBySelector(SELECTORS.drawer), this.getRegisteredElement('main'))
            this.#registerWindowResizeEvent()
        } catch (error) {
            console.error(error)
        }
    }

    #statefulUpdate = () => {
        const rootElement = this.getRegisteredElement('root')
        const mainElement = this.getRegisteredElement('main')

        switch (this.#drawerState) {
            case DRAWER_STATE.open:
                rootElement.classList.add(DRAWER_OPEN_CLASS)
                mainElement.classList.add(DRAWER_OPEN_CLASS)

                break;
            case DRAWER_STATE.closed:
            default:
                rootElement.classList.remove(DRAWER_OPEN_CLASS)
                mainElement.classList.remove(DRAWER_OPEN_CLASS)
        }
    }
    
    #registerWindowResizeEvent = () => {
        if (window) {
            window.addEventListener('resize', debounce(
                () => {
                    /**
                     * If the menu drawer is currently open, refresh the state,
                     * but skip any open/close animation
                     */
                    if (this.resizeCallback && this.isDrawerOpen()) {
                        if (!typeof this.resizeCallback === 'function') {
                            throw new Error('resizeCallback is not a function')
                        }

                        this.resizeCallback();
                    }
                }, 500, {
                    leading: false,
                    trailing: true,
                },
            ));
        }
    }
    
    openDrawer = () => {
        this.#drawerState = DRAWER_STATE.open
        this.#statefulUpdate()
    }
    
    closeDrawer = () => {
        this.#drawerState = DRAWER_STATE.closed
        this.#statefulUpdate()
    }

    isDrawerOpen = () => {
        return this.#drawerState === DRAWER_STATE.open
    }
}